/* global logger */
/* eslint-disable class-methods-use-this */

const moment = require('moment');
const { deliveryTypes: DeliveryType, movementType } = require('pando-constants');
const Freight = require('./freight');

class ArrivalDelay {
  arrivalDelayWithFixedValue(data) {
    try {
      const deliveryType = data.deliveryType;
      const slaData = data.sla.arrivalDelay;
      let maxArrivalSlaPercentage = 0;
      let amount = 0;
      if (!slaData || !slaData.isSlaBreached || (deliveryType === DeliveryType.PTL && !data.isPtlSlaEnabled)) {
        amount = 0;
      } else {
        /*
          1. find source with first truckIn
          2. select that source for arrival delay days calculation
        */
        const source = (Object.values(data.sla.detention.actualDetentionWindowByDepot)
          .sort((a, b) => a.startedAt - b.startedAt))[0];

        /* taking first destination for fetching sla charges for Vendor and Return Movement
          [Changes as part of = PAN-20380]
        */
        const destination = data.destinations[0];
        let locationId;
        if (data.movement === movementType.INWARD || data.movement === movementType.RETURNS) {
          locationId = (data.routeDetails && data.routeDetails.depot_id) || destination.locationId;
        } else {
          locationId = (data.routeDetails && data.routeDetails.depot_id) || source.locationId;
        }
        maxArrivalSlaPercentage = (slaData.charge[locationId] &&
          slaData.charge[locationId].maxArrivalSlaPercentage) || 0;
        const arrivalDelayDays = moment(data.sla.detention
          .actualDetentionWindowByDepot[source.locationId].startedAt)
          .diff(moment(data.sla.arrivalDelay.breachedAt), 'seconds');
        if (arrivalDelayDays > 0) {
          const DayinSeconds = 24 * 60 * 60;
          // added 1 to compensate days less than 1
          const days = Math.floor(arrivalDelayDays / DayinSeconds) + 1;
          amount = days * ((slaData.charge[locationId] &&
            slaData.charge[locationId].arrivalDelayCost) || 0);
          amount = Number(amount.toFixed(2));
        }
      }
      if (maxArrivalSlaPercentage) {
        const freight = new Freight();
        const freightRate = freight.freightRateMaximum(data);
        const maxArrivalSlaFromFreight = (maxArrivalSlaPercentage / 100) * freightRate.freightCharge;
        amount = Math.min(Number(maxArrivalSlaFromFreight.toFixed(2)), amount);
      }
      return amount;
    } catch (error) {
      logger.error(error);
      return 0;
    }
  }
}
module.exports = ArrivalDelay;
